import {
    Container,
    Title,
    Paper,
    Button,
    Select, Chip, Chips
} from "@mantine/core";
import {useEffect, useState} from "react";
import {EnvironmentRegistry} from "../../../services/registry/environmentRegistry";
import {popNotification} from "../setup/notification/notificationUtils";
import {useAuth} from "../../../providers/AuthProvider";
import {cloneKpis, KpiCloneRequest} from "../../../services/kpiService";
import { TranslationEnum, usePortalTranslation } from "../../../providers/TranslationProvider";

export type CloneKpiProps = {
    kpiNames: string[],
    close: () => void
}

export function CloneKpi(props: CloneKpiProps) {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const [lobs, setLobs] = useState<string[]>([]);

    const [env, setEnv] = useState<string | null>("DEV");

    const [lob, setLob] = useState<string | null>(null);


    const authContext = useAuth();

    useEffect(() => {
        setLob(null);

        const fetchLobs = async () => {
            if (env != null) {
                const currentLobs = await EnvironmentRegistry.getLobs(env);
                setLobs(currentLobs);
            } else {
                setLobs([])
            }
        }
        fetchLobs()
            .catch(e => {
                console.log("something went wrong", e);
                setLobs([])
            })
    }, [env]);


    async function submitRequest() {
        if (env == null) {
            popNotification("Missing Information", "Please choose the environment", "red");
            return;
        }
        if (lob == null) {
            popNotification("Missing Information", "Please select the target LOB", "red")
            return;
        }
        try {
            const requestBody: KpiCloneRequest = {
                targetEnvironment: env,
                targetLob: lob,
                kpiNames: props.kpiNames
            }
            const response = await cloneKpis(requestBody, authContext);
            if (response.status === 200) {
                alert("successfully saved")
                props.close()
            } else {
                alert("something went wrong")
            }
        } catch (error) {
            console.log(error)
            popNotification("Something went wrong", "Something went wrong please try later", 'red')
        }
    }

    return <Container size={700} my={40}>
        <Title
            align="center"
            sx={(theme) => ({
                fontFamily: `Greycliff CF, ${theme.fontFamily}`,
                fontWeight: 700
            })}
        >
            Clone your KPIs
        </Title>

        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
            <Chips position="center" multiple={true} value={["1", "2", "3"]}>
                {props.kpiNames.map(name => <Chip checked={true}  key={"kpi_name_"+ name} value={name}>{name}</Chip>)}
            </Chips>
            <Select
                label="Choose Target Environment"
                placeholder="Pick one"
                searchable
                nothingFound={translate(TranslationEnum.common_portal,"No options")}
                onChange={setEnv}
                value={env}
                data={['DEV', 'UAT', 'PROD', 'DEMO', "LOCAL"]}
            />

            <Select
                label="Choose Target LOB"
                placeholder="Pick one"
                searchable
                nothingFound={translate(TranslationEnum.common_portal,"No options")}
                value={lob}
                onChange={setLob}
                data={lobs}
            />

            <Button onClick={() => submitRequest()} fullWidth mt="xl">
                Clone
            </Button>
        </Paper>
    </Container>
}